import { BASEURI, headers } from "../../utils/helper"
import { asyncThunkWrapper } from "../thunkHandler"
import { createAsyncThunk } from "@reduxjs/toolkit"

// Handle create
export const handleCreateWebinar = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {
    return asyncThunkWrapper(
      {
        data,
        method: "POST",
        headers: {
          ...headers(),
          "Content-Type": "multipart/form-data"
        },
        url: `${BASEURI}/specialist/webinar/create`,
      },
      thunkAPI
    )
  }
)

// Handle retrieve
export const handleRetrieveWebinar = createAsyncThunk(
  "retrieveAll",
  async (id, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/specialist/webinar/retrieve/${id}`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// Handle retrieve all
export const handleRetrieveAllWebinar = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      type: data?.type || null,
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/specialist/webinar/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)
export const handleRetrieveSingleWebinar = createAsyncThunk(
  "retrieveSingle",
  async (id, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/specialist/webinar/retrieve/${id}`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)
export const handleUpdateWebinar = createAsyncThunk(
  "update",

    async ({ id, data }, thunkAPI) => {

    return asyncThunkWrapper(
      {
        data,
        method: "PUT",
        headers: {
          ...headers(),
          "Content-Type": "multipart/form-data"
        },
         url: `${BASEURI}/specialist/webinar/update/${id}`,
      },
      thunkAPI
    )
  }

)

// Handle delete
export const handleDeleteWebinar = createAsyncThunk(
  "delete",
  async (id, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "DELETE",
        headers: headers(),
        url: `${BASEURI}/specialist/webinar/delete/${id}`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// Handle retrieve all bookings (webinar)
export const handleRetrieveAllBookings = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }
    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/specialist/booking/webinar/${data?.id}`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)
